import useSwr from "swr";

const FetchTypeRegions = () => {
  let url = `${process.env.REACT_APP_URL_BACKEND}api/v1/type-region`;
  const { data, error } = useSwr(url);
  return { data, error };
};

export default FetchTypeRegions;
